module.exports = __webpack_public_path__ + "static/media/ARG.0dd42f64.svg";